Vue.asyncComponent('bp-block-type', {
    data() {
        return {
            isActive: false,
        }
    },
    props: {
        name: {
            type: String,
        },
        nameDefault: {
            type: String,
            required: true,
        },
        description: {
            type: String,
        },
        type: {
            type: String,
            required: true,
        },
        preview: {
            type: String,
            required: false,
        },
        areChildrenAllowed: {
            type: Boolean,
            required: true,
        },
        icon: {
            type: String,
        },
    },
    computed: {
        currentName() {
            return this.name ? this.name : this.nameDefault;
        }
    },
    methods: {
        startDrag(e) {
            this.isActive = true;
            e.dataTransfer.dropEffect = 'move';
            e.dataTransfer.effectAllowed = 'move';

            this.$emit('dragstart');
        },
        endDrag() {
            this.isActive = false;
            this.$emit('dragend');
        }
    }
}, 'blueprints/editor/bp-block-type.html');